import React from 'react'
import { TimePicker } from '@material-ui/pickers'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  field: {
    marginBottom: 4,
    '& > label': {
      top: -3,
    }
  },
  input: {
    height: 48,
  }
})

const CustomTimePicker = props => {
  const classes = useStyles()
  const {
    input: {
      name,
      onChange,
      value,
    },
    onChangeField,
    meta,
    ...rest
  } = props
  const showError = ((meta.submitError && !meta.dirtySinceLastSubmit) || meta.error) && meta.touched

  const handleOnChange = e => {
    onChange(e)
    //onChangeField()
  }

  return (
    <TimePicker
      className={classes.field}
      inputVariant="filled"
      cancelLabel="Отмена"
      {...rest}
      name={name}
      helperText={showError ? meta.error || meta.submitError : undefined}
      error={showError}
      onChange={e => handleOnChange(e)}
      value={value === '' ? null : value}
      ampm={false}
      InputProps={{ className: classes.input }}
    />
  )
}

export default CustomTimePicker
